import { MitAuthDto } from "@api-types/integrations/MitAuthDto";
import {
	MitIdWidgetDto,
	MitIdWidgetRequest,
} from "@api-types/integrations/MitIdWidgetDto";
import { MidIdUserInfoDto } from "@api-types/integrations/MidItUserInfoDto";
import {
	DeviceDetector,
	getCurrentCulture,
	httpClient,
	mapObjectToUrlEncoded,
} from "@utils";
import { ApiRequestContextData } from "@utils/api-config/types";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";

export class MitIdApiService {
	static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/integrations/mitid`;
	}

	private static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);

		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	/*
		auth_config_init => WidgetConfigLoadFailed 400955
		auth_request_failed => WidgetInitFailed 400956
		auth_unhandled_error => WidgetInitUnhandledError 400957
		auth_invalid_login_url => WidgetUrlNotValid 400958
	*/
	static async getMitIdWidgetInfo(
		redirectUrl: string
	): Promise<MitIdWidgetDto> {
		const lng = getCurrentCulture() === "da" ? "da" : "en";
		let body = {
			language: lng,
			redirectUrl: redirectUrl,
		} as MitIdWidgetRequest;
		if (DeviceDetector.isMobileApp) {
			body.enableAppSwitch = true;
			body.appSwitchOs = "android";
			body.appSwitchUrl = redirectUrl;
		}
		return await httpClient.post(
			`${this.baseUrl}/auth/widget`,
			JSON.stringify(body),
			this.getRequestHeaders()
		);
	}

	static async getUserAdditionalInfo(
		formData: MitAuthDto
	): Promise<MidIdUserInfoDto> {
		const headers = this.getRequestHeaders();
		headers["Content-Type" as keyof HeadersInit] =
			"application/x-www-form-urlencoded";

		const body = mapObjectToUrlEncoded(formData);

		return await httpClient.post(
			`${this.baseUrl}/auth/resolve-user-info`,
			body,
			headers
		);
	}
}
